// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-info-index-wrapper-plzae{display:grid;grid-gap:48px}.pages-info-index-wrapper-plzae.pages-info-index-desktop-btnln{grid-template-columns:repeat(4,1fr)}.pages-info-index-pageWrapper-zavwd{padding-bottom:48px}.pages-info-index-pageWrapper-zavwd.pages-info-index-mobile-bofcg{padding-top:48px}.pages-info-index-link-bxfyu{color:#111;display:block;text-decoration:none}.pages-info-index-link-bxfyu:hover{color:var(--color-primary-hover)}.pages-info-index-title-htfqu{font-size:20px;font-weight:700;text-align:center}.pages-info-index-image-dicwv{border-radius:6px;height:auto!important;margin-bottom:12px;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "pages-info-index-wrapper-plzae",
	"desktop": "pages-info-index-desktop-btnln",
	"pageWrapper": "pages-info-index-pageWrapper-zavwd",
	"mobile": "pages-info-index-mobile-bofcg",
	"link": "pages-info-index-link-bxfyu",
	"title": "pages-info-index-title-htfqu",
	"image": "pages-info-index-image-dicwv"
};
module.exports = ___CSS_LOADER_EXPORT___;
